import { onDelegatedClick } from '../functions.js';

export default class MySelectionElement extends HTMLElement {

    connectedCallback() {

        onDelegatedClick(this, '.cartitem__delete', event => {
            // event.preventDefault();

            // let cartItem = event.selectorTarget.closest('.cartitem');

            // let formData = genericElementToFormData(cartItem);

            // fetch('/cart/remove', {
            //     method: 'POST',
            //     body: formData
            // })
            // .then(res => res.json())
            // .then(res => {
                
            // }).catch(error => {
            //     console.error('Error:', error);
            // }
            // cartItem.remove();
        });
    }

}
window.customElements.define('my-selection', MySelectionElement);

